import type { CurriculumElement, EducationClass } from 'services/api';
import { getClassKey } from './get-class-keys';

export const mergeTableClasses = (
  apiClasses: EducationClass[],
  elements: CurriculumElement[],
): EducationClass[] => {
  const existingKeys = new Set(apiClasses.map((cls) => getClassKey(cls)));
  const merged = [...apiClasses];
  let nextSyntheticId = -1;

  elements.forEach((el) => {
    const key = getClassKey(el);
    if (existingKeys.has(key)) {
      return;
    }

    merged.push({
      id: nextSyntheticId,
      parallel: el.parallel as EducationClass['parallel'],
      litera: el.litera,
    });
    existingKeys.add(key);
    nextSyntheticId -= 1;
  });

  return merged;
};
